import React from 'react';
import { useTranslation } from 'react-i18next';
import { DeliveryPublicColiInfoDataModel } from 'src/features/DeliveryPublicColiInfo/delivery-public-colis-info.types';

type Props = {
  shipping: DeliveryPublicColiInfoDataModel;
  theme?: 'light' | 'dark';
  testID?: string;
};

export const ShippingRecap: React.FC<Props> = ({ theme = 'light', shipping, testID = 'ShippingRecap' }) => {
  const { t } = useTranslation();

  const totalColis = shipping.colis.length;
  const totalColisDelivered = shipping.colis.filter((coli) => coli.status === 'DELIVERED').length;

  if (theme === 'dark') {
    return (
      <div data-testid={testID} className="">
        <div className="max-w-md mx-auto bg-white border border-gray-200 rounded-lg shadow-md p-4">
          {/* Primary Title Section */}
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-primary"> {t('client-delivery-requests.page-title')}</h2>
            <p
              className="text-sm text-gray-600"
              dangerouslySetInnerHTML={{
                __html: t('client-delivery-requests.sub-title'),
              }}
            />
          </div>

          {/* Widget Details */}
          <div className="text-center">
            <h3 className="text-md font-semibold text-gray-500">{t('client-delivery-requests.shipping-number')}</h3>
            <p className="text-xl font-semibold text-gray-900 hover:underline cursor-pointer">{shipping.tracker}</p>
          </div>
          <div className="my-4 border-t border-gray-300"></div>
          <div className="flex justify-between items-center text-gray-600">
            <span className="font-medium text-sm">{t('client-delivery-requests.colis-delivered')}</span>
            <span className="text-md font-semibold text-gray-800">
              {t('client-delivery-requests.total-colis', { delivred: totalColisDelivered, total: totalColis })}
            </span>
          </div>
          <div className="mt-4 text-center text-xl text-gray-400">{shipping.toAgency.name}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 rounded-lg p-4 shadow-sm md:w-4/5 m-auto">
      <h2 className="text-blue-600 text-lg font-semibold mb-1">{t('client-delivery-requests.page-title')}</h2>
      <p
        className="text-gray-500 text-sm"
        dangerouslySetInnerHTML={{
          __html: t('client-delivery-requests.sub-title'),
        }}
      />

      {/* Tracking Info */}
      <div className="mt-4 border-t border-gray-300 pt-4">
        <div className="flex justify-between items-center text-sm">
          <span className="text-gray-600 font-medium">{t('client-delivery-requests.shipping-number')}</span>
          <span className="text-gray-900 font-bold">{shipping.tracker}</span>
        </div>
        <div className="flex justify-between items-center text-sm mt-2">
          <span className="text-gray-600 font-medium">{t('client-delivery-requests.colis-delivered')}</span>
          <span className="text-gray-900">{shipping.toAgency.name}</span>
        </div>
      </div>
    </div>
  );
};
